import { createFileRoute } from '@tanstack/react-router'

import { MembersScreen } from '@/features/users/members-screen'

export const Route = createFileRoute('/_app/_org/settings/members')({
  component: MembersScreen,
})
